import React, { ReactElement } from 'react'
import { SectionResult, SectionTabs, SectionError, Info } from './sections'
import { ErrorBoundaryComponent } from '@src/components/UtmGenerator'

function Content(): ReactElement {
  return (
    <ErrorBoundaryComponent>
      <Info />
      <SectionResult />
      <SectionTabs />
      <SectionError />
    </ErrorBoundaryComponent>
  )
}

export default Content
